

import { Component, Mixins, VModel, Watch } from "vue-property-decorator";
import AuthDigitalPassword from "../mixins/AuthDigitalPassword";
import DigitalSignNotFoundDialog from "./DigitalSignNotFoundDialog.vue";
import DigitalSignNotConnectedDialog from "./DigitalSignNotConnectedDialog.vue";
import IBInputField from "@/components/TextField/IBInputField.vue";
import IBDialog from "@/components/Dialog/IBDialog.vue";
import RegExpCore from "@/mixins/reg-exp/reg-exp-core";
import IBDialogFieldFocusing from "@/components/IBDialog/mixins/IBDialogFieldFocusing";

@Component({
	components: {
		DigitalSignNotFoundDialog,
		DigitalSignNotConnectedDialog,
		IBInputField,
		IBDialog
	}
})
export default class DigitalSignPasswordDialog extends Mixins(
	AuthDigitalPassword,
	RegExpCore,
	IBDialogFieldFocusing,
) {

	@VModel({ type: Boolean, default: true })
	model!: boolean

	passwordDialogIsActive: boolean = false

	beforeDestroy() {
		this.clearState();
	}

	async checkDigitalSignAndActivatePasswordDialog() {
		await this.checkDigitalSign();

		this.passwordDialogIsActive = !this.digitalSignNotFound
			&& !this.digitalSignNotConnected;
	}

	clearState() {
		this.passwordDialogIsActive = false;
		this.passwordErrorMessageLocal = '';
		this.passwordLocal = '';
	}

	onKeypress(event: any) {
		if(event.key === 'Enter') {
			this.onSubmit();
		};
    }

	@Watch('model')
	onModelChanged() {
		if (this.model) {
			this.checkDigitalSignAndActivatePasswordDialog();

			this.focusFieldAfterTransition(
				this.focusPasswordField.bind(this)
			);
		} else {
			this.clearState();
		}
	}

	@Watch('passwordDialogIsActive')
	onPasswordDialogIsActiveChanged() {
		this.model = this.passwordDialogIsActive;
	}

	@Watch('digitalSignNotFound')
	onDigitalSignNotFoundChanged() {
		this.model = false;
	}

	@Watch('digitalSignNotConnected')
	onDigitalSignNotConnectedChanged() {
		this.model = false;
	}

}

